import filterIcon from "@src/assets/svg/filter-icon.svg";
import filterIconClear from "@src/assets/svg/filter-icon-clear.svg";
import filterIconDisabled from "@src/assets/svg/filter-icon-disabled.svg";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { useEffect, useState } from "react";
import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { useI18N } from "@src/language/language-context";
import { RootState } from "@src/reducers/store";
import { useSelector } from "react-redux/es/hooks/useSelector";

export const useFilterIconNewMachineStructureHook = () => {
  const logger = getLogger();
  const i18n = useI18N();

  const texts = {
    tooltip: i18n("modules.filterIcon.tooltip"),
    clearButtonTooltip: i18n("modules.filterIcon.clearButtonTooltip"),
    clearButtonText: i18n("modules.filterIcon.clearButtonText"),
  };

  const activeNodeId = useSelector(
    (state: RootState) => state.yourSlice.activeMachineStructureNode,
  );

  const machineStructureNodeset = getMachineStructureNodeset();

  const [filteredNodesCount, setFilteredNodesCount] = useState(0);
  const [nodesCount, setNodesCount] = useState(
    machineStructureNodeset.getFlatMap()
      ? machineStructureNodeset.getFlatMap().size
      : 0,
  );

  const [showFilter, setShowFilter] = useState(false);

  const handleClickFilterFunction = () => {
    logger.debug("useFilterIconNewMachineStructureHook", {
      function: "handleClickFilterFunction",
    });
    return getNodeManager().handleClickFilterMachineStructure();
  };

  const handleClickClearFilterListFunction = () => {
    logger.debug("useFilterIconNewMachineStructureHook", {
      function: "handleClickClearFilterListFunction",
    });
    return getNodeManager().clearFilterForNewMachineStructureList();
  };

  const handleReturnedIconForFilter = () => {
    let icon;
    if (filteredNodesCount === 0 && nodesCount <= 1) {
      icon = filterIconDisabled;
    } else if (!showFilter) {
      return filterIcon;
    } else if (showFilter) {
      return filterIconClear;
    }
    return icon;
  };

  useEffect(() => {
    const updateFilterbutton = () => {
      logger.debug("useFilterIconNewMachineStructureHook", {
        function: "updateFilterbutton",
      });
      const newFilteredFlatMap = machineStructureNodeset.getFilteredFlatMap();
      const newFlatmap = machineStructureNodeset.getFlatMap();
      setFilteredNodesCount(newFilteredFlatMap.size);
      setNodesCount(newFlatmap.size);
      setShowFilter(machineStructureNodeset.getShowFilterPanel());
    };

    machineStructureNodeset.addObserver(updateFilterbutton);

    return () => {
      machineStructureNodeset.removeObserver(updateFilterbutton);
    };
  }, [machineStructureNodeset.getFlatMap()]);

  return {
    filterIconSvgString: handleReturnedIconForFilter(),
    handleClickClearFilterListFunction: handleClickClearFilterListFunction,
    handleClickFilterFunction: handleClickFilterFunction,
    iconButtonText: filteredNodesCount ? `${filteredNodesCount}` : "",
    iconButtonVariant: showFilter ? "green-background" : "",
    isApplyMarginLeft: showFilter ? true : false,
    isIconButtonDisabled: nodesCount <= 1 ? true : false,
    isShowClearButton: showFilter ? true : false,
    texts: texts,
  };
};
